
export type SortOrderParamParameter = typeof SortOrderParamParameter[keyof typeof SortOrderParamParameter];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const SortOrderParamParameter = {
  ASC: 'ASC',
  DESC: 'DESC',
} as const;
